import { useMutation } from '@tanstack/react-query';
import { useConnectionDetailApi } from './useConnectionDetailApi';
import { PensionProConfiguration } from '../types';

export function useUpdatePensionProConfiguration({
  applicationId,
  connectionId,
  configuration,
}: {
  applicationId: string;
  connectionId: string;
  configuration?: Pick<PensionProConfiguration, 'enabled' | 'ein_override'>;
}) {
  const api = useConnectionDetailApi();
  const { isPending, data, mutateAsync, isError } = useMutation({
    mutationKey: [
      'update-pensionpro-configuration',
      applicationId,
      connectionId,
      configuration,
    ],
    mutationFn: (
      configuration: Pick<PensionProConfiguration, 'enabled' | 'ein_override'>,
    ) =>
      api.updatePensionProConfiguration(
        applicationId,
        connectionId,
        configuration,
      ),
  });

  return {
    connectionConfiguration: data,
    isLoading: isPending,
    mutateAsync,
    isError,
  };
}
